// if you're adding a key here, you should probably also add it to SEARCH_RESULT_CATEGORY_EVENT_NAMES
export const SEARCH_RESULT_CATEGORY_NAMES: { [category: string]: string } = {
  all: "All results",
  article: "Articles",
  brand: "Brands",
  dispensary: "Locations",
  menuItem: "Products",
  strain: "Strains",
};

export const SEARCH_RESULT_CATEGORY_EVENT_NAMES: {
  [category: string]: string;
} = {
  all: "all results",
  article: "show me - articles",
  brand: "show me - brands",
  dispensary: "show me - locations",
  menuItem: "show me - menu items",
  strain: "show me - strains",
};

export const SEARCH_INITIAL_TAKE = 5;
export const INITIAL_RESULT_LENGTH = 4;
